import toast from "react-hot-toast";

import { apiPost } from "../../../components/Common/Axios";
import { RootState, useAppSelector } from "../../../store";
import { useState } from "react";
import { Button } from "components/ui/button";
import { FormCard } from "components/Layout/PageShell";

function SettingUser() {
  const me = useAppSelector((state: RootState) => state.user.me);

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");

  const handleCurrentPassword = (e: any) => {
    setCurrentPassword(e.target.value.trim());
  };

  const handleNewPassword = (e: any) => {
    setNewPassword(e.target.value.trim());
  };

  const handleNewPasswordConfirm = (e: any) => {
    setNewPasswordConfirm(e.target.value.trim());
  };

  const handleUpdate = async () => {
    if (newPassword.length < 4) {
      toast.error("비밀번호는 4자리 이상이어야 합니다.");
      return;
    }
    if (newPassword !== newPasswordConfirm) {
      toast.error("새 비밀번호가 일치하지 않습니다.");
      return;
    }

    const result = await apiPost("/user/password", {
      currentPassword,
      newPassword,
    });

    if (result.error) {
      toast.error("비밀번호 변경에 실패했습니다.", result);
      console.error("change password error", result.error);
      return;
    }
    toast.success("비밀번호 변경했습니다.");
  };

  return (
    <FormCard>
      <div className="text-xl font-semibold pb-1">비밀번호 변경</div>
      <div className="text-sm text-gray-500 pb-8">
        {me.name}님의 비밀번호를 변경합니다.
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-[120px_200px] gap-x-3 gap-y-2 text-base items-center">
        <div className="text-left sm:text-right">현재비밀번호</div>
        <div>
          <input
            type="password"
            value={currentPassword}
            onChange={handleCurrentPassword}
            className="border border-gray-300 px-2 py-1 rounded-sm"
          />
        </div>
        <div className="text-left sm:text-right">새 비밀번호</div>
        <div>
          <input
            type="password"
            value={newPassword}
            onChange={handleNewPassword}
            className="border border-gray-300 px-2 py-1 rounded-sm"
          />
        </div>
        <div className="text-left sm:text-right">새 비밀번호 확인</div>
        <div>
          <input
            type="password"
            value={newPasswordConfirm}
            onChange={handleNewPasswordConfirm}
            className="border border-gray-300 px-2 py-1 rounded-sm"
          />
        </div>
        <div></div>
        <Button size="md" variant="primary" onClick={() => handleUpdate()}>
          변경
        </Button>
      </div>
    </FormCard>
  );
}

export default SettingUser;
